var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newmodal__footer",class:{ centered: !_vm.hasSlot }},[_vm._t("default"),(!_vm.hasSlot)?_c('div',{staticClass:"newmodal__footer__default"},[_c('Button',{attrs:{"text":_vm.$t('continue')},on:{"click":function($event){return _vm.$emit('continue')}}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }